import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleCard from '@/components/base/ArticleCard';
import { categories, categoryArticles, siteConfig } from '@/mocks/site';

export default function CategoryDetail() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const articles = slug ? categoryArticles[slug] || [] : [];

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <div className="text-center">
          <i className="ri-emotion-sad-line text-5xl text-foreground-300"></i>
          <p className="mt-4 text-foreground-600">未找到该分类</p>
          <a href="/categories" className="mt-4 inline-block text-primary-500 hover:text-primary-600 whitespace-nowrap">返回分类列表</a>
        </div>
      </div>
    );
  }

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 撸撸社`,
    description: category.description,
    url: `${siteConfig.url}/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: siteConfig.name,
      url: siteConfig.url,
    },
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: siteConfig.url },
      { '@type': 'ListItem', position: 2, name: '分类浏览', item: `${siteConfig.url}/categories` },
      { '@type': 'ListItem', position: 3, name: category.name },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-24 pb-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-1.5 text-sm mb-6" aria-label="面包屑导航">
              <a href="/" className="text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">首页</a>
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              <a href="/categories" className="text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">分类浏览</a>
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              <span className="text-foreground-800 font-medium whitespace-nowrap">{category.name}</span>
            </nav>

            <div className="relative w-full h-48 md:h-64 rounded-lg overflow-hidden mb-10">
              <img
                src={category.imageUrl}
                alt={category.name}
                className="w-full h-full object-cover"
                title={`撸撸社${category.name}分类`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 flex items-center justify-center text-primary-500 bg-background-50/90 rounded-full">
                    <i className={`${category.icon} text-xl`}></i>
                  </div>
                  <h1 className="text-2xl md:text-3xl font-heading text-white">
                    {category.name}
                  </h1>
                </div>
                <p className="text-sm text-white/80 max-w-2xl">{category.description}</p>
              </div>
            </div>

            {articles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {articles.map((article) => (
                  <ArticleCard
                    key={article.id}
                    id={article.id}
                    title={article.title}
                    excerpt={article.excerpt}
                    category={category.name}
                    categorySlug={category.slug}
                    author={article.author}
                    authorAvatar={article.authorAvatar}
                    readTime={article.readTime}
                    likes={article.likes}
                    date={article.date}
                    imageUrl={article.imageUrl}
                    isHot={article.isHot}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <i className="ri-inbox-line text-5xl text-foreground-300"></i>
                <p className="mt-4 text-foreground-500">该分类暂无文章</p>
              </div>
            )}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}